// @ts-nocheck
/* global __REACT_NATIVE_WEB_CONFIG__ */
/* eslint no-undef: "error" */

module.exports = __REACT_NATIVE_WEB_CONFIG__
